import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import DataTable from '../data-table/data-table';
import Modal from '../modal/modal';
import './trainers.css';
import {deleteTrainer, createTrainer, fetchTrainers} from './trainers.actions';
import { fetchSomeUsers } from '../users/users.actions';
import ConfirmationModal from '../confirmation-modal/confirmation-modal';
import Loader from '../loader-component/loader';

class Trainers extends React.Component {

    state = {
        showAddModal: false,
    };

    componentDidMount() {
        this.props.fetchTrainers();
    }

    render() {
        const { trainers, loading, users, fetchSomeUsers, createTrainer, loggedId } = this.props;
        const TableLoader = ()=> <div style={{ display: 'none' }}></div>;
        return (
            <div className='courses-container trainers'>
                <Loader show={ loading ? true : false } message={'Carregando, por favor aguarde...'} />
                <div className='new-entity-btn'>
                    <button onClick={() => this.setState({ showAddModal: true })} title='Novo Instrutor'>
                        <i className='fa fa-plus' />
                    </button>
                </div>
                <DataTable
                    className='courses-table trainers'
                    data={trainers}
                    columns={COLUMNS}
                    loading={loading}
                    loadComponent={ TableLoader }
                    exportName={`trainers-${moment().toISOString()}.csv`}
                />
                {this.state.showAddModal &&
                    <NewTrainerModal
                        fetchSomeUsers={fetchSomeUsers}
                        createTrainer={createTrainer}
                        loggedId={loggedId}
                        users={users}
                        onClose={() => this.setState({ showAddModal: false })}/>
                }
            </div>
        );
    }
}

const mapStateToProps = ({ trainers, users, login }) => ({ trainers: trainers.data, loading: trainers.loading, users, loggedId: login.userInfo.UserId });
const mapDispatchToProps = dispatch => bindActionCreators({ createTrainer, fetchSomeUsers, fetchTrainers }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Trainers);

class NewTrainerModal extends React.Component {

    handleAddTrainer = (trainer) => {
        this.props.createTrainer(trainer);
        this.props.onClose();
    };

    render() {
        const { users, fetchSomeUsers, loggedId, ...props } = this.props;
        return (
            <Modal show={true} {...props}>
                <div className='new-course-modal new-trainer-modal'>
                    <Loader show={ users.loading ? true : false } message={'Carregando, por favor aguarde...'} />
                    <div className='modal-header'>
                        <span>Adicionar Instrutor</span>
                        <i className='fa fa-times' onClick={ this.props.onClose } title='Fechar'/>
                    </div>
                    <DataTable
                        className='new-trainer-users-table'
                        data={users.some.filter(u => u.userId !== loggedId)}
                        pages={users.pages}
                        exportable={false}
                        manual
                        fetchMethod={fetchSomeUsers}
                        columns={this.COLUMNS}
                    />
                </div>
            </Modal>
        );
    }

    COLUMNS = [
        { Header: 'usuário', accessor: 'email' },
        { Header: 'Ação', Cell: row => <div className='actions-row'>
            <button title='tornar instrutor' onClick={() =>
                this.handleAddTrainer(row.original)}><i className='fa fa-user-plus' /></button>
        </div> },
    ];
}

class ActionsGroup extends React.Component {

    state = {
        askConfirmation: false,
    };

    render() {
        const { loggedId, original } = this.props;
        return (
            <div className='actions-row'>
                <button disabled={loggedId === original.userId}
                    title='Remover' onClick={() => this.setState({ askConfirmation: true })}>
                    <i className='fa fa-trash' />
                </button>
                {this.state.askConfirmation &&
                <ConfirmationModal
                    show={true}
                    onClose={() => this.setState({ askConfirmation: false })}
                    onConfirm={() => this.props.deleteTrainer(original.userId)}
                />}
            </div>
        );
    }
}

const ActionsCell = connect(({ login }) => ({ loggedId: login.userInfo.UserId }),
    dispatch => bindActionCreators({ deleteTrainer }, dispatch))(ActionsGroup);

const COLUMNS = [
    { Header: 'Email', searchable: true, accessor: 'email' },
    { Header: 'Nome', searchable: true, accessor: 'name' },
    { Header: 'Ações', exportable: false, Cell: props => <ActionsCell {...props}/>, sortable: false },
];



// WEBPACK FOOTER //
// ./src/components/trainers/trainers.js